import styled from 'styled-components';
import Button from 'web-components/Button';

export const Clients = styled.div`
  display: flex;
  width: 100%;
  height: 220px;
  overflow-y: auto;
  flex-direction: column;
  margin-top: 16px;
  padding-top: 20px;
  border-top: 1px solid #E7EDF2;

  & > *:not(:last-child) {
    margin-bottom: 10px;
  }
`;

export const BackButton = styled(Button).attrs({
  ghost: true,
  spacing: 'large',
  appearance: 'empty',
})`
  border-color: #292929;
`;

export const Footer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  padding-top: 35px;
  border-top: 1px solid #E7EDF2;

  button {
    width: 150px;
    height: 44px;
    font-size: 16px;
  }
`;
